import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export interface Payout {
  id: string;
  creatorProfileId: string;
  amount: number;
  currency: string;
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED';
  fee?: number;
  netAmount?: number;
  startDate: string;
  endDate: string;
  processedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export const payoutsService = {
  async getAccountStatus() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/payouts/account/status`, { headers: { Authorization: `Bearer ${token}` } });
    return res.data as { account: any | null };
  },
  async upsertAccount(payload: { provider: 'STRIPE' | 'PAYPAL' | 'BANK'; details?: Record<string, any> }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/payouts/account`, payload, { headers: { Authorization: `Bearer ${token}` } });
    return res.data as { account: any };
  },
  async getBalance() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/payouts/balance`, { headers: { Authorization: `Bearer ${token}` } });
    return res.data as { available: number; currency: string; totalReceived: number; totalPaidOut: number };
  },
  async list() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/payouts`, { headers: { Authorization: `Bearer ${token}` } });
    return res.data as { payouts: any[] };
  },
  async request(amount: number, currency = 'USD') {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/payouts/request`, { amount, currency }, { headers: { Authorization: `Bearer ${token}` } });
    return res.data as { payout: any };
  },
};
